import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from './session.service';
import { getHeaders } from '../utils/headersUtils';
import { IBuscarSecretos } from '../../models/credenciales/credenciales.models';

@Injectable({
  providedIn: 'root'
})
export class CredencialesService {
  //private servicio: string = environment.backend.secretInteraction.servicio;
  private endpoint: string = environment.backend.secretInteraction.url;

  constructor(
    private http: HttpClient,
    private _sessionService: SessionService
  ) { }

  public inputRut: string[] = [
    'SII',
    'CLAVE_UNICA'
  ]

  listarSecretosOrgyUsuarios(pagina?: number, nElementos?: number, rut?: string): Observable<any> {
    let params = new HttpParams();
    params = params.append("rut", rut ? rut : '');

    if(pagina || pagina === 0) {
      params = params.append("pagina", pagina);
    }

    if(nElementos || nElementos === 0) {
      params = params.append("nElementos", nElementos);
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<any>(`${this.endpoint}listarSecretosOrgyUsuarios`, { params, headers });
  }

  obtenerCantidadElementos(): Observable<any> {
    const params = new HttpParams(); 

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<any>(`${this.endpoint}nElementosUsuarios`, { params, headers });
  }

  crearActualizarCredenciales(rut: string, servicios: any): Observable<any> {
    const payload: any = {
      rut: rut,
      services: servicios
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.post<any>(`${this.endpoint}crearActualizarSecreto`, payload, { headers: headers });
  }

  obtenerContrato(): Observable<any> {
    const params = new HttpParams();

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<any>(`${this.endpoint}obtenerContrato`, { params, headers });
  }

  validarCredenciales(username: string, password: string, service: string): Observable<any> {
    const payload: any = {
      user: username,
      password: password,
      service: service
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.post<any>(`${this.endpoint}validarCredenciales`, payload, { headers: headers });
  }

  validarCredencialesDinamico(request: any, service: string): Observable<any> {
    const payload: any = {
      service: service
    }
    if(request && Object.keys(request).length > 0) {
      for (const key in request) {
        payload[key] = request[key];
      }
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.post<any>(`${this.endpoint}validarCredenciales`, payload, { headers: headers });
  }

  validarCredencialesSecreto(rut: string, service: string): Observable<any> {
    const payload: any = {
      rut,
      service
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.post<any>(`${this.endpoint}validarCredencialesSecreto`, payload, { headers: headers });
  }

  borrarCredenciales(rut: string, service: string): Observable<any> {
    const payload: any = {
      rut: rut,
      service: service
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.post<any>(`${this.endpoint}borrarSecreto`, payload, { headers: headers });
  }

  listarCargasMasivas(): Observable<any> {
    const params = new HttpParams(); 

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<any>(`${this.endpoint}listarCargasMasivas`, { params, headers });
  }

  obtenerArchivoCargaMasiva(idTransaccion: string): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("idTransaccion", idTransaccion);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<any>(`${this.endpoint}obtenerArchivoCargaMasiva`, { params, headers });
  }

  iniciarCargaMasivaCreds(csv: string): Observable<any> {
    const payload: any = {
      csv: csv
    }

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.post<any>(`${this.endpoint}iniciarCargaMasivaCreds`, payload, { headers: headers });
  }

  buscarSecretos(rut: string = ''): Observable<IBuscarSecretos> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IBuscarSecretos>(`${this.endpoint}buscarSecretos`, { params, headers });
  }

  buscarSecretosInformeComercial(rut: string = ""): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("rut", rut);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<any>(`${this.endpoint}buscarSecretos`, { params, headers });
  }

}
